import { useMemo } from 'react'

import { useGetUser } from '@/feature/auth'
import { useIntl } from 'react-intl'

import { stringToColor } from '@/lib/utils/colors'

import messages from './UserAvatarLink.messages'
import { getAvatarColorSeed, getFleetName } from './UserAvatarLink.utils'

export const useUserAvatarLink = () => {
  const { data: userData } = useGetUser()
  const { formatMessage } = useIntl()

  const avatarColors = useMemo(() => {
    if (!userData) {
      return undefined
    }

    return stringToColor(getAvatarColorSeed(userData))
  }, [userData])

  const fleetName = useMemo(() => getFleetName(userData), [userData])

  return {
    userData,
    avatarColors,
    fleetName,
    avatarAlt: formatMessage(messages.imageAlt),
  }
}
